/* @flow */
import createChainedFunction from 'utils/createChainedFunction';
import Electron from 'lib/Electron';
import WebNotificationStore from 'notifications/WebNotificationStore';

function focusWindow() {
  if (Electron.isAvailable()) {
    Electron.showCurrentWindow();
  }
  window.focus();
}

class WebNotificationClient {
  // $FlowFixMe where can we get this type?
  handleNotifications(router) {
    WebNotificationStore.addChangeListener(() => {
      WebNotificationStore.getPendingNotifications().forEach(notif => {
        const { url } = notif._options;
        if (url) {
          // Don't show the notification if the user is in Chat, and is a chat notification
          if (url.startsWith('/chat') && router.isActive('/chat') && document.hasFocus()) {
            notif.dismissNotification();
          } else {
            const redirect = () => router.push(url);
            notif.setOnClick(createChainedFunction(focusWindow, redirect));
            notif.dispatch();
          }
        } else {
          notif.setOnClick(focusWindow);
          notif.dispatch();
        }
      });
    });
  }
}

export default new WebNotificationClient();
